import authActionConstants from '../constants/authActionConstants';

const initialState = {
  currentUser: null,
  loading: true,
  phoneConfirmationData: null,
  phoneConfirmationCodeSentAttempts: 0,
  phoneConfirmationSent: false,
  phoneConfirmedLoading: false,
  organizationAccessRequestLoading: false,
};

const authReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case authActionConstants.GET_CURRENT_USER:
      return {
        ...state,
        currentUser: action.payload,
      };
    case authActionConstants.GET_CURRENT_USER_LOADING_ON:
      return {
        ...state,
        loading: true,
      };
    case authActionConstants.GET_CURRENT_USER_LOADING_OFF:
      return {
        ...state,
        loading: false,
      };
    case authActionConstants.GET_NUMBER_CONFIRMATION:
      return {
        ...state,
        phoneConfirmationData: null,
        phoneConfirmationSent: false,
      };
    case authActionConstants.GET_NUMBER_CONFIRMATION_SUCCESS:
      return {
        ...state,
        phoneConfirmationData: action.payload.formData,
        phoneConfirmationCodeSentAttempts: action.payload.attempts,
        phoneConfirmationSent: true,
        phoneConfirmedLoading: false,
      };
    case authActionConstants.RESEND_CONFIRMATION_CODE:
      return {
        ...state,
        resendConfirmationCodeLoading: true,
      };
    case authActionConstants.RESEND_CONFIRMATION_CODE_SUCCESS:
      return {
        ...state,
        phoneConfirmationData: action.payload.formData,
        phoneConfirmationSent: true,
        phoneConfirmationCodeSentAttempts: action.payload.attempts,
        resendConfirmationCodeLoading: false,
      };
    case authActionConstants.RESEND_CONFIRMATION_CODE_ERROR:
      return {
        ...state,
        resendConfirmationCodeLoading: false,
      };
    case authActionConstants.CLEAR_PHONE_CONFIRMATION_DATA:
      return {
        ...state,
        phoneConfirmationData: null,
        phoneConfirmationSent: false,
        phoneConfirmationCodeSentAttempts: 0,
      };
    case authActionConstants.CREATE_ORGANIZATION_ACCESS_REQUEST:
      return {
        ...state,
        organizationAccessRequestLoading: true,
      };
    case authActionConstants.CREATE_ORGANIZATION_ACCESS_REQUEST_SUCCESS:
      return {
        ...state,
        organizationAccessRequestLoading: false,
      };
    case authActionConstants.CREATE_ORGANIZATION_ACCESS_REQUEST_ERROR:
      return {
        ...state,
        organizationAccessRequestLoading: false,
      };
    default:
      return state;
  }
};

export default authReducer;
